const defaultSettings = {
    DEV_REACT_APP_BASE_URL: 'https://cmsapi-dev.biomerics-env.com/',
    PROD_REACT_APP_BASE_URL: 'https://cms-api.biomerics-env.com/', 
  };
  const UrlSetting = {defaultSettings, ...process.env};
  export default UrlSetting;